import { useMemo } from "react";

export const useUserTypesMap = () => {
  const userTypesMap = useMemo(
    () => ({
      1: "Requester",
      2: "Primary buyer",
      3: "Primary seller",
    }),
    [],
  );

  return { userTypesMap };
};
